import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const m = document.cookie.match(/(?:^|; )csrf_token=([^;]+)/);
  if (m) config.headers["X-CSRF-Token"] = decodeURIComponent(m[1]);
  return config;
});

http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        await http.post("/auth/refresh");
        return http(orig);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (id) => `${API}/files/${id}`;

export const CONTACT_PRICE = "Hubungi admin untuk informasi tarif.";

export const rp = (n) => "Rp " + Number(n).toLocaleString("id-ID");

export function formatPrice(t) {
  if (t.price_type === "fixed" && t.price_min) return rp(t.price_min);
  if (t.price_type === "start" && t.price_min) return `Mulai ${rp(t.price_min)}`;
  if (t.price_type === "range" && t.price_min && t.price_max) return `${rp(t.price_min)} – ${rp(t.price_max)}`;
  return null;
}

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "";

export function buildWaMessage(f) {
  return [
    "Halo Admin Nanina Care ☺️🙏🏻",
    "",
    "Saya ingin bertanya mengenai layanan Nanina Care.",
    "",
    `Nama: ${f.name.trim()}`,
    `Alamat / Area: ${f.area.trim()}`,
    `Layanan: ${f.service}`,
    `Tanggal yang Diinginkan: ${f.dateText}`,
    `Jam yang Diinginkan: ${f.time.trim()}`,
    `Homecare: ${f.homecare === "ya" ? "YA" : "TIDAK"}`,
    `Pertanyaan: ${f.question?.trim() || "-"}`,
    "",
    "Mohon informasi dan konfirmasi jadwalnya, nggeh.",
    "",
    "Terima kasih.",
  ].join("\n");
}

export const packageImageUrl = (p) =>
  `${API}/package-images/${p.id}?v=${encodeURIComponent(p.published_at || p.updated_at || "")}`;

export const FAQ_CATS = { umum: "Umum", kebidanan: "Kebidanan", daycare: "Daycare", homecare: "Homecare", babycare: "Babycare", momcare: "Momcare", newborn: "Newborn Care" };

export const waUrl = (number, message) => `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const AVAIL_LABEL = { available: "Tersedia", full: "Jadwal Penuh", temp_closed: "Tutup Sementara", closed: "Tutup" };

export const NO_SCHEDULE = "Hubungi admin untuk informasi jadwal layanan.";

export const hoursText = (h) => {
  const time = h.open && h.close ? `${h.open.replace(":", ".")} – ${h.close.replace(":", ".")}` : "";
  return [time, h.note].filter(Boolean).join(" · ") || "-";
};

export const testimonialPhotoUrl = (t) =>
  `${API}/testimonial-photos/${t.id}?v=${encodeURIComponent(t.published_at || t.updated_at || "")}`;
